<mat-dialog-title><b>İzin İsteği Firma Seçimi</b></mat-dialog-title>
<br />
<span>(VKN yi kopyalayınız)</span>
<mat-dialog-content>
  <div style="display: flex">
    <mat-form-field
      style="width: 275px"
      appearance="outline"
      class="filter-fields"
    >
      <mat-label>{{ "Firma Listesi" }}</mat-label>
      <mat-select [(ngModel)]="selectedCustomer" name="branch">
        <mat-option
          *ngFor="let customer of customerList"
          [value]="customer.identityId"
        >
          {{ customer.title }} - {{ customer.identityId }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <span>&nbsp;</span>
    <mat-form-field appearance="outline" class="filter-fields">
      <mat-label>{{ "İzin Süresi" }}</mat-label>
      <mat-select [(ngModel)]="selectedLeaveTime" name="leaveTime">
        <mat-option *ngFor="let data of leaveTime" [value]="data.value">
          {{ data.viewValue }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" style="padding: 0">
  <button mat-raised-button (click)="changeClick()" color="primary">
    Kaydet
  </button>
  <button mat-raised-button matDialogClose color="primary">Kapat</button>
</mat-dialog-actions>
